import { Activity } from '~/types/bootcamp'
import { BootcampActivityEventId } from '~/bootcamp/types/bootcamp.types'
import { selectCurrentActivityType, selectCurrentDifficultyLevel } from '~/bootcamp/slices/bootcamp-activity.slice'
import { useAppSelector } from '~/redux/hooks'

import { useGetCollectedRewardSet } from './useGetCollectedRewards'

export default function useGetCurrentRewardLevel(eventIds: BootcampActivityEventId[], activities: Activity[]): number {
  const activityType = useAppSelector(selectCurrentActivityType)
  const difficultyLevel = useAppSelector(selectCurrentDifficultyLevel)
  const rewardsCollected = useGetCollectedRewardSet(eventIds)

  const activity = activities.find((elem) => elem.type === activityType)
  const difficulty = activity?.difficulties[difficultyLevel - 1]
  const difficultyRewards = new Array(difficulty?.rewards).fill(null).map((_, index) => index + 1)
  const targetRewardLevel = difficultyRewards.find((value) => !rewardsCollected.has(value))

  if (!targetRewardLevel) {
    return difficulty ? difficulty.rewards : rewardsCollected.size + 1
  } else {
    return targetRewardLevel
  }
}
